import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { openBookingModal } from './BookingModal';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const ticking = useRef(false);

  useEffect(() => {
    const handleScroll = () => {
      if (!ticking.current) {
        window.requestAnimationFrame(() => {
          // Skip scroll effect on mobile (< 900px)
          const isMobile = window.innerWidth < 900;
          if (isMobile) {
            setIsScrolled(false); // Always false on mobile
          } else {
            setIsScrolled(window.scrollY > 20);
          }
          ticking.current = false;
        });
        ticking.current = true;
      }
    };

    // Initial check
    handleScroll();
    
    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [mobileMenuOpen]);

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/features', label: 'Features' },
    { path: '/workflows', label: 'Workflows' },
    { path: '/how-it-works', label: 'How It Works' },
    { path: '/blog', label: 'Blog' },
    { path: '/case-studies', label: 'Case Studies' },
  ];

  return (
    <header className={`site-header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <Link to="/" className="logo-link">
          <img 
            src="/skye-logo-hero.png" 
            alt="Skye AI" 
            className="logo"
          />
        </Link>

        <nav className={`main-nav ${mobileMenuOpen ? 'mobile-open' : ''}`}>
          {navLinks.map((link) => (
            <Link 
              key={link.path}
              to={link.path} 
              className={`nav-link ${location.pathname === link.path ? 'active' : ''}`}
            >
              {link.label}
            </Link>
          ))}
          <button 
            className="nav-cta-mobile btn-gradient"
            onClick={() => { openBookingModal(); setMobileMenuOpen(false); }}
          >
            Book a Growth Call
          </button>
        </nav>

        <button 
          className="nav-cta btn-gradient"
          onClick={openBookingModal}
        >
          Book a Growth Call
        </button>

        <button 
          className="mobile-menu-btn"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>
    </header>
  );
};

export default Header;
